import { Box, Grid, Tab, Tabs } from "@mui/material";
import React from "react";
import theme from "../../theme";
import ViewMerchantShopUser from "./ViewMerchantShopUser";
import MerchantReceiptNew from "./MerchantReceiptNew";
import MerchantProfileNew from "./MerchantProfileNew";
import { getFeaturePermissions } from "../../util/permissions";
import { useAppSelector } from "../../redux/hooks";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";

const ViewMerchantTabs = () => {
  const [tab, setTab] = React.useState("profile");
  const { getUserPermission: getMerchantPermission } = usePermissionGetter(
    "merchant",
    "merchants"
  );
  const { getUserPermission: getMerchantReceiptPermission } =
    usePermissionGetter("merchant", "receipts");
  const { getUserPermission: getMerchantShopUserPermission } =
    usePermissionGetter("merchant", "shop_user");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
  };

  const permissions = useAppSelector(
    (state: any) => state.persistReducers.login.permissions
  );

  return (
    <Grid
      sx={{
        background: theme.color?.background,
        borderRadius: 4,
        overflow: "hidden",
      }}
      width={"100%"}
      height={"100%"}
    >
      <Grid
        borderBottom={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
        pt={1}
      >
        <Box ml={3}>
          <Tabs
            TabIndicatorProps={{
              style: {
                backgroundColor: theme.color?.secondary,
              },
            }}
            value={tab}
            onChange={handleChange}
            aria-label="tabs menu"
          >
            {getMerchantPermission("read") && (
              <Tab
                value={"profile"}
                id={"profile"}
                label="Profile"
                style={{
                  textTransform: "capitalize",
                  fontFamily: theme.font?.fontFamily.primary,
                  color: tab === "profile" ? theme.color?.secondary : undefined,
                }}
              />
            )}

            {getMerchantShopUserPermission("read") && (
              <Tab
                value={"shopUser"}
                id={"shopUser"}
                label="Shop User"
                style={{
                  textTransform: "capitalize",
                  fontFamily: theme.font?.fontFamily.primary,
                  color:
                    tab === "shopUser" ? theme.color?.secondary : undefined,
                }}
              />
            )}
            {getMerchantReceiptPermission("read") && (
              <Tab
                value={"receipt"}
                id={"receipt"}
                label="Receipt"
                style={{
                  textTransform: "capitalize",
                  fontFamily: theme.font?.fontFamily.primary,
                  color: tab === "receipt" ? theme.color?.secondary : undefined,
                }}
              />
            )}
          </Tabs>
        </Box>
      </Grid>
      <Grid width={"100%"} height={"100%"}>
        {tab === "profile" ? (
          <MerchantProfileNew />
        ) : tab === "shopUser" ? (
          <ViewMerchantShopUser />
        ) : (
          <MerchantReceiptNew />
        )}
      </Grid>
    </Grid>
  );
};

export default ViewMerchantTabs;
